export default __webpack_public_path__ + "static/media/Snd5.2ae57ae0.mp3";